<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <div class="header-button">
      <search-form
        ref="searchForm"
        :fields="search"
      />
    </div>

    <el-table
      :data="riding_card_order"
      resource="riding_card_order"
    >
      <el-table-column
        prop="no"
        label="订单编号"
        align="center"
        show-overflow-tooltip
        min-width="120"
      />
      <!-- <el-table-column
        prop="user_truename"
        label="用户姓名"
        align="center"
        show-overflow-tooltip
        min-width="100"
      >
        <template slot-scope="scope">
          {{ scope.row.users.nickname }}({{ scope.row.user_truename }})
        </template>
      </el-table-column> -->
      <el-table-column
        prop="user_mobile"
        label="用户手机号"
        align="center"
        show-overflow-tooltip
        min-width="120"
      />
      <el-table-column
        prop="area_name"
        label="区域名称"
        align="center"
        show-overflow-tooltip
        min-width="120"
      />
      <el-table-column
        prop="card_riding_name"
        label="骑行卡名称"
        align="center"
        show-overflow-tooltip
        min-width="120"
      />
      <el-table-column
        prop="money"
        label="原价"
        align="center"
        show-overflow-tooltip
        min-width="90"
      />
      <el-table-column
        prop="discount"
        label="折扣"
        align="center"
        show-overflow-tooltip
        min-width="90"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.discount = 1"
            type="info"
          >无折扣</el-tag>
          <el-tag
            v-else
            type="success"
          >{{ scope.row.discount }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="pay_time"
        label="支付时间"
        align="center"
        show-overflow-tooltip
        min-width="100"
      />
      <el-table-column
        prop="pay_type_name"
        label="支付类型"
        align="center"
        show-overflow-tooltip
        min-width="120"
      />
      <el-table-column
        prop="pay_status"
        label="支付状态"
        align="center"
        show-overflow-tooltip
        min-width="100"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.pay_status ==1"
            type="success"
          >成功</el-tag>
          <el-tag
            v-else
            type="danger"
          >失败</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="pay_money"
        label="支付金额"
        align="center"
        show-overflow-tooltip
        min-width="90"
      >
        <template slot-scope="scope">
          <el-tag>{{ scope.row.pay_money }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at"
        label="创建时间"
        align="center"
        show-overflow-tooltip
        min-width="120"
      />
      <el-table-column
        label="状态"
        align="center"
        show-overflow-tooltip
        min-width="100"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.status == 1 && scope.row.pay_status == 1"
            type="success"
          >成功</el-tag>
          <el-tag
            v-else
            type="danger"
          >未支付</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        show-overflow-tooltip
        width="100"
        fixed="right"
      >
        <template #default="{ row, $index }">
          <el-button-group>
            <el-button @click="DetailClick(row)">详情</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>
    <!-- 弹框详情信息 -->
    <el-dialog
      title="详情"
      :visible.sync="dialogVisible"
      width="20%"
    >
      <div class="info-wrp">
        <div class="title">订单详情</div>
        <div class="info-item">
          <span>订单编号:</span>
          <span>{{ row.no }}</span>
        </div>
        <div class="info-item">
          <span>用户姓名:</span>
          <span>{{ row.user_truename }}</span>
        </div>
        <div class="info-item">
          <span>用户手机号:</span>
          <span>{{ row.user_mobile }}</span>
        </div>
        <div class="info-item">
          <span>支付时间:</span>

          <span>{{ row.pay_time }}</span>
        </div>
        <div class="info-item">
          <span>支付状态:</span>
          <span v-if="row.status">成功</span>
          <span v-else>失败</span>
        </div>
        <div class="info-item">
          <span>支付金额:</span>
          <span style="width:60%;">{{ row.pay_money }}</span>
        </div>
      </div>
      <div class="infodiv">
        <div class="title">骑行卡详情</div>
        <div class="info-item">
          <span>是否限次:</span>
          <span v-if="card_riding.is_limit_times == 1">限次</span>
          <span v-else> 不限次 </span>
        </div>
        <div
          class="info-item"
          v-if="card_riding.is_limit_times == 1"
        >
          <span>限次次数:</span>
          <span>{{ card_riding.times }}（次）</span>
        </div>
        <div class="info-item">
          <span>有效时间:</span>
          <span>{{ card_riding.effective_days }}（天）</span>
        </div>
        <div class="info-item">
          <span>原价:</span>
          <span>{{ card_riding.price }}</span>
        </div>
      </div>
    </el-dialog>
    <!-- 弹框详情信息end -->
  </el-card>
</template>

<script>
import SearchForm from "@c/SearchForm";
import Pagination from "@c/Pagination";
import { getRidingCardOrder } from "@/api/card-riding-order";
import { getAreas } from "@/api/area";
import { mixinsAutoPageSize } from "@/libs/utils";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../../env";
export default {
  name: "Index",
  components: {
    SearchForm,
    Pagination
  },
  data() {
    return {
      search: [
        {
          type: "el-select",
          field: "area_id",
          label: "骑行区域",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },
        {
          field: "no",
          label: "订单编号"
        },
        {
          type: "super-input",
          field: "mobile_nickname",
          label: "用户手机号"
        },
        {
          type: "el-select",
          field: "pay_status",
          label: "是否支付成功",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              id: 1,
              name: "成功"
            },
            {
              id: 0,
              name: "失败"
            }
          ]
        }
      ],
      riding_card_order: [],
      row: {},
      card_riding: {},
      dialogVisible: false,
      page: null,
      first_blood: true
    };
  },
  methods: {
    DetailClick(row) {
      this.dialogVisible = true;
      this.row = row;
      this.card_riding = row.card_riding;
    }
  },
  async created() {
    const [{ data: areas }] = await Promise.all([getAreas({ all: 1 })]);

    this.search[0].options.push.apply(this.search[0].options, areas);
    if (this.$store.state.users.user.roles[0] === "administrator") {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 })
      ]);
      if (env.isPosSwitch == true) {
        this.search.push({
          type: "el-select",
          field: "merchant_id",
          label: "商户",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        });
        this.search[4].options.push.apply(
          this.search[4].options,
          merchant.data
        );
      }
    }
  },
  mixins: [mixinsAutoPageSize],
  watch: {
    $route: {
      async handler(newVal) {
        await this.autoPageSize(53, newVal);
        const {
          data: { data, meta }
        } = await getRidingCardOrder(newVal.query);
        this.riding_card_order = data;
        this.page = meta;
      },
      immediate: true
    }
  }
};
</script>
<style lang="scss" scoped>
.header-button {
  display: flex;
  justify-content: space-between;
  .selections {
    display: inline-block;
    margin-right: 10px;
  }
}
.info-wrp .title {
  font-size: 16px;
  // margin: 20px 0 10px;
  padding-top: 10px;
  border-top: 1px solid #ccc;
}
.info-wrp .info-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 10px;
}
.info-wrp .info-item > span:first-child {
  display: inline-block;
  margin-right: 8px;
  width: 120px;
  text-align: right;
}
.info-wrp .pic-wrp > div:first-child {
  width: 120px;
  text-align: right;
}
.infodiv {
  line-height: 1.15;
  // border-top: 1px solid #ccc;
  padding-bottom: 10px;
  .title {
    border-top: 1px solid #ccc;
    font-size: 16px;
    margin: 10px;
    padding-top: 10px;
  }
  .info-item {
    margin-left: 30px;
    margin-bottom: 10px;
    :first-child {
      display: inline-block;
      width: 85px;
      text-align: right;
      font-size: 14px;
      margin-right: 8px;
    }
  }
}
</style>
